module.exports = __webpack_public_path__ + "img/7_72.1346c7d4.png";